import store from "@/store/index";

// import locals from "./local.json";
import { vocabulary, languages } from "../../../public/local.js";
export function __(text, values = []) {
  const { code } = store?.state.local ? store.state.local : { code: "he", dir: "rtl" };
  const currentLang = languages.find(l => l.code === code)
  const languageTranslations = vocabulary.find((l) => +l.LID === +currentLang.id);
  let finalTranslation = languageTranslations[text] ? languageTranslations[text] : text;



  if (typeof values === "object" && values.length)
    values.forEach((v, i) => {
      finalTranslation = finalTranslation.replace(new RegExp(`\\{${i}\\}`, "gi"), v);
    });

  return finalTranslation
}

//  function oldTranslator(text, values = []) {
//   const { code } = store
//     ? store.state.local
//     : {
//       code: "he",
//       dir: "rtl",
//     };

//   let val = text;

//   if (locals[text]) if (locals[text][code]) val = locals[text][code];

//   if (typeof values === "object" && values.length)
//     values.forEach((v, i) => {
//       val = val.replace(new RegExp(`\\{${i}\\}`, "gi"), v);
//     });

//   return val;
// }

export default {
  install: (app, options) => {
    app.config.globalProperties.__ = (text, values) => __(text, values);

    app.provide("i18n", options);
  },
};
